import { QueryEntity } from '@datorama/akita';
import { IMusimapQueryParamsState, MusimapFiltersStorage } from './musimap-filters.storage';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IMusimapQueryParams } from '../musimap-common/musimap-common.interface';
import { MusimapCollection } from '../musimap-models/musimap-collection.model';
import { MusimapFilterModel } from '../musimap-models/musimap-filter.model';
import { MUSIMAP_FILTERS } from '../musimap-common/musimap-common.enum';

@Injectable()
export class MusimapFiltersQuery extends QueryEntity<IMusimapQueryParamsState, IMusimapQueryParams> {
  public readonly isReady$: Observable<boolean> = this.select(data => data.isReady);

  public readonly params$: Observable<IMusimapQueryParams> = this.select(data => data.params);

  public readonly filtersCollection: MusimapCollection<MusimapFilterModel> = new MusimapCollection<MusimapFilterModel>({
    indexBy: 'label',
  });

  public readonly asidePanelIsOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public readonly additionalPanelIsOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(protected store: MusimapFiltersStorage) {
    super(store);
  }

  public getFilters = (requiredFilters: string[]): MusimapFilterModel[] =>
    this.filtersCollection.getItems(requiredFilters);

  public getDivisions = (): string[] => {
    return this.filtersCollection.getItem(MUSIMAP_FILTERS.DIVISIONS)?.items?.selection?.map(item => item.label) || [];
  };

  public get needUpdate(): boolean {
    return this.filtersCollection.getItems().some(item => item.isActive.value);
  }

  public get openedFilter(): MusimapFilterModel | null {
    return this.filtersCollection.selection;
  }
}
